import React from 'react';
import styled from 'styled-components';
import { minBreakpointQuery } from '../../styles';
import { Button } from '.';

const StyledSectionFooter = styled.footer`
  margin-top: 30px;
  text-align: center;

  ${minBreakpointQuery.small`
    margin-top: 45px;
  `}

  ${minBreakpointQuery.large`
    margin-top: 60px;
  `}
`;

const StyledButton = styled(Button)`
  width: 100%;
  max-width: 380px;
`;

export const SectionFooter = ({ link }) =>
  link && (
    <StyledSectionFooter>
      <StyledButton to={link.pageUrl} hasArrow={true}>
        {link.text}
      </StyledButton>
    </StyledSectionFooter>
  );
